<template>
  <div id="wizard">
    <p>Thank you for trying the demo!</p>

    <p>Here you would be able to enter all necessary information and book the ticket.</p>
  </div>
</template>

<script>
export default {
  name: 'wizard'
}
</script>

<style scoped>
#wizard {
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 2px;
  font-family: 'Maven Pro', sans-serif;
  padding: 31px;
  background: #e6e6e6;
}
</style>



// WEBPACK FOOTER //
// Book.vue?03435aa3